import React from 'react';
import ReactMarkdown from 'react-markdown';
import { blankLinks } from '../modules/markdown/plugins';

export const ModuleSliderImage = props => {
  let imgPath = require(`../images/${props.image.file}`);
  return (
    <div>
      <figure
        style={{
          paddingBottom: '50%',
          position: 'relative',
          margin: '0 5px 20px',
          border: '2px solid #ccc'
        }}
      >
        <img
          alt={props.text}
          src={imgPath}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }}
        />
      </figure>
      {props.text && (
        <ReactMarkdown
          source={props.text}
          renderers={{
            blanklink: props => (
              <a href={props.url} target="_blank" rel="noopener noreferrer">
                {props.children}
              </a>
            )
          }}
          astPlugins={[blankLinks]}
        />
      )}
    </div>
  );
};
